"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedVfxEffectHandler = exports.LinkedVfxEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const core_1 = require("../../vfx/core");
const EffectType_1 = require("../EffectType");
class LinkedVfxEffectArgs {
    constructor(vfxType, vfxId) {
        this.vfxType = vfxType;
        this.vfxId = vfxId;
        this.__type = EffectType_1.EffectType.LinkedVfx;
        this.__typeName = "LinkedVfx";
        this.name = "LinkedVfx";
        this.harmful = false;
    }
}
exports.LinkedVfxEffectArgs = LinkedVfxEffectArgs;
let LinkedVfxEffectHandler = class LinkedVfxEffectHandler {
    apply(sequence, container, state) { }
    remove(sequence, container, state) {
        switch (state.args.vfxType) {
            case "Aura":
                sequence.push(new core_1.CancelAuraVfxStepArgs(state.args.vfxId));
                return;
        }
    }
};
LinkedVfxEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.LinkedVfx)
], LinkedVfxEffectHandler);
exports.LinkedVfxEffectHandler = LinkedVfxEffectHandler;
